import { Link } from 'react-router-dom';
import PictureImage from '../Common/PictureImage';
import { IMAGE_ALT } from '../../seo/imageAltText';
import { MULTI_CHANNEL_RELATED_BLOG_CARDS } from '../../data/multiChannelRelatedBlogCards';
import '../Blogs/BlogPosts.css';
import './MultiChannelRelatedBlogs.css';

const MultiChannelRelatedBlogs = () => (
  <section className="mcf-related-blogs" aria-labelledby="mcf-related-blogs-title">
    <div className="mcf-related-blogs-inner">
      <header className="mcf-related-blogs-head">
        <span className="mcf-related-blogs-eyebrow">From our blog</span>
        <h2 id="mcf-related-blogs-title" className="mcf-related-blogs-title">
          Multi-Channel Fulfilment Guides
        </h2>
        <p className="mcf-related-blogs-lead">
          Deep dives on choosing a partner, running every channel from one warehouse, and scaling UK ecommerce fulfilment.
        </p>
      </header>

      <div className="blog-posts-grid mcf-related-blogs-grid">
        {MULTI_CHANNEL_RELATED_BLOG_CARDS.map((post) => (
          <Link
            key={post.slug}
            to={`/blog/${post.slug}`}
            className="blog-post-card-link"
          >
            <article className="blog-post-card">
              <div className="blog-post-image-wrapper">
                <PictureImage
                  src={post.image}
                  alt={IMAGE_ALT.blogCard(post.title)}
                  title={post.title}
                  loading="lazy"
                  decoding="async"
                  className="blog-post-image"
                />
              </div>
              <div className="blog-post-content">
                <span className="blog-post-date">{post.date}</span>
                <h3 className="blog-post-title">{post.title}</h3>
                <p className="blog-post-description">{post.description}</p>
                <div className="blog-post-tags">
                  {post.tags.map((tag) => (
                    <span key={tag} className="blog-post-tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default MultiChannelRelatedBlogs;
